import styled, { css } from 'styled-components';

import { Wrapper as BaseWrapper } from '../Block.styled';
import scrollbarStyle from 'Common/styles/scrollbar';

export const Wrapper = styled(BaseWrapper)`
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;
    border: none;
    background: transparent;
    padding: 0;
    margin: 0;
    border-radius: unset;
`;

export const Top = styled.div`
    position: relative;
`;

export const Heading = styled.h3`
    font-size: 1.25rem;
    margin: 0 0 1rem 0;
`;

export const Legend = styled.legend`
    font-size: 1rem;
    font-weight: 300;
    display: block;
    position: absolute;
    top: 0rem;
    left: 0.6rem;
    transform: translateY(50%);
`;

export const ItemList = styled.ul<{ $maxHeight: boolean | string }>`
    ${scrollbarStyle()}
    overflow-y: auto;
    list-style: none;
    padding: 0.75rem 0 0;
    margin: 0;

    ${({ $maxHeight }) =>
        $maxHeight &&
        (typeof $maxHeight === 'string'
            ? css`
                  max-height: ${$maxHeight};
              `
            : css`
                  max-height: 20rem;
              `)}
`;

export const Item = styled.li`
    position: relative;
    padding: 0 0.5rem;

    & {
        margin-bottom: 1rem;
    }
`;
